import { post, request } from "./api";

/** A product's client lists, as the product page and the Audience step show them (workers/src/routes/lists.ts). */
export interface ListView {
  id: string;
  name: string;
  state: string;
  size: number | null;
  rowsSent: number;
  rowsInvalid: number;
  addedAt: string;
  updatedAt: string | null;
  outdated: boolean;
  usedBy: number;
  note: string | null;
  likeReady: boolean;
  /** Meta found fewer than 1,000, how many it will not say. */
  belowFloor: boolean;
  /** People like them, as Meta made them from this list. */
  like: { state: "ready" | "making" | "failed"; note: string | null } | null;
  formerIds: string[];
  replacing: { id: string; state: string; rowsSent: number; note: string | null } | null;
}
export interface ListsView {
  lists: ListView[];
  /** The people who sent one of the pixel's events, as Meta holds them. */
  events: { event: string; state: string; size: number | null; note: string | null }[];
  pixel: boolean;
}
export interface MadeList {
  id: string;
  name: string;
  state: string;
  note: string | null;
  rowsSent: number;
}

const base = (productId: string) => `/products/${encodeURIComponent(productId)}/lists`;
export const listsApi = {
  product: (productId: string) => request<ListsView>(base(productId)),
  forGoal: (goalId: string) => request<ListsView>(`/goals/${encodeURIComponent(goalId)}/audience/lists`),
  add: (productId: string, name: string) => post<{ list: MadeList }>(base(productId), { name, consent: true }),
  replace: (productId: string, listId: string) => post<{ list: MadeList }>(`${base(productId)}/${encodeURIComponent(listId)}/replace`, { consent: true }),
  retry: (productId: string, listId: string) => post<{ list: MadeList }>(`${base(productId)}/${encodeURIComponent(listId)}/retry`),
  people: (productId: string, listId: string, users: { email?: string; phone?: string }[]) =>
    post<{ received: number; invalid: number }>(`${base(productId)}/${encodeURIComponent(listId)}/people`, { users }),
  done: (productId: string, listId: string) => post<{ list: MadeList }>(`${base(productId)}/${encodeURIComponent(listId)}/done`),
  remove: (productId: string, listId: string) => request<{ ok: true }>(`${base(productId)}/${encodeURIComponent(listId)}`, { method: "DELETE" }),
};

/** The list a goal's tick stands for now: the same one, or the one that replaced it. */
export const listFor = (lists: ListView[], id: string) => lists.find((l) => l.id === id || l.formerIds.includes(id));
